import React from 'react';
import {VideoSlideBaseRenderer} from './video-slide-base.renderer';
import {IVideoSwiperSlideController} from "../models/video-swiper-slide-controller.interface";
import {
    VideoStreamSlideComponent
} from "../../../components/video-slides/slides-types/video-stream/video-stream-slide.component";
import {GameInfo} from "../../games/game-info";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {VideoTypeEnum} from "../../video/models/video-type.enum";

export class VideoStreamGameSlideRenderer extends VideoSlideBaseRenderer {

    constructor(gameInfo: GameInfo, services: IServiceFactoryExtended) {
        super(gameInfo, VideoTypeEnum.VideoStream, services)
    }

    protected _renderVideoSlide(context: IVideoSwiperSlideController, uniqueKey: string): React.ReactElement {
        return (
            <VideoStreamSlideComponent
                key={uniqueKey}
                gameInfo={this.gameInfo}
                videoPlayer={context.videoPlayer}
                isActive={context.isActiveSlide}
                onPlayGameClick={this._playGame}
                onBookGame={this._onBookGame}
                onRemoveBookedGame={this._onRemoveBookedGame}
            />
        );
    }
}
